// Fixed labels of the student site in the theme's language (theme file "language": "ar" | "en", see
// docs/themes/THEME-SPEC.md). The teacher's own content (names, course titles, descriptions) is shown as written.
// Theme.js calls setLanguage() before any page renders its content.

const STRINGS = {
  // ---- shared ----
  notFound: { ar: "لم يتم العثور على صفحة لهذا الدومين.", en: "No page was found for this domain." },
  home: { ar: "الرئيسية", en: "Home" },
  courses: { ar: "الكورسات", en: "Courses" },
  gallery: { ar: "المعرض", en: "Gallery" },
  about: { ar: "عن المدرس", en: "About" },
  resources: { ar: "مصادر", en: "Resources" },
  contact: { ar: "تواصل", en: "Contact" },
  freeVideos: { ar: "فيديوهات مجانية", en: "Free videos" },
  live: { ar: "البث المباشر", en: "Live" },
  liveTitle: { ar: "الحصص المباشرة", en: "Live sessions" },
  liveLead: { ar: "ادخل حصص المدرس المباشرة من هنا. زرار الدخول بيشتغل أول ما المدرس يبدأ.", en: "Join your teacher's live sessions here. The join button turns on as soon as the teacher starts." },
  loading: { ar: "جاري التحميل ...", en: "Loading ..." },
  noLive: { ar: "مفيش حصص مباشرة متحددة دلوقتي.", en: "No live sessions are scheduled right now." },
  liveNow: { ar: "مباشر", en: "LIVE" },
  minutes: { ar: "{n} دقيقة", en: "{n} min" },
  joinNow: { ar: "ادخل دلوقتي", en: "Join now" },
  notStarted: { ar: "لسه ما بدأتش", en: "Not started yet" },
  backToLive: { ar: "الحصص المباشرة →", en: "← Live sessions" },
  liveRemindersOn: { ar: "التذكير شغال: هيوصلك إشعار على الجهاز ده قبل كل حصة مباشرة.", en: "Reminders are on: you'll get a notification on this device before each live session." },
  liveTurnOff: { ar: "إيقاف", en: "Turn off" },
  liveBlocked: { ar: "الإشعارات مقفولة للموقع ده. افتحها من علامة القفل جنب العنوان، وبعدين اعمل تحديث للصفحة.", en: "Notifications are blocked for this site. Allow them from the lock icon next to the address, then reload." },
  liveIos: { ar: "على الآيفون / الآيباد: اضغط مشاركة ← إضافة إلى الشاشة الرئيسية، افتح الموقع من هناك، وبعدين شغّل التذكير.", en: "On iPhone / iPad: tap Share → Add to Home Screen, open the site from there, then turn reminders on." },
  liveUnsupported: { ar: "المتصفح ده ما بيدعمش الإشعارات. جرّب Chrome أو Edge أو Firefox.", en: "This browser can't show notifications. Try Chrome, Edge or Firefox." },
  liveRemindersOff: { ar: "خلّي يوصلك إشعار على الجهاز ده قبل كل حصة مباشرة، حتى لو الموقع مقفول.", en: "Get a notification on this device before each live session, even when the site is closed." },
  liveTurnOn: { ar: "شغّل التذكير", en: "Turn on reminders" },
  downloadApp: { ar: "حمّل التطبيق", en: "Download Desktop App" },
  hi: { ar: "أهلاً، {name}", en: "Hi, {name}" },
  logout: { ar: "تسجيل الخروج", en: "Logout" },
  loginRegister: { ar: "دخول / تسجيل", en: "Login / Register" },
  openMenu: { ar: "فتح القائمة", en: "Open menu" },
  rights: { ar: "© {year} {name}. جميع الحقوق محفوظة.", en: "© {year} {name}. All rights reserved." },
  whatsapp: { ar: "كلّمنا على واتساب", en: "Chat on WhatsApp" },
  close: { ar: "إغلاق", en: "Close" },

  // ---- gym / membership home blocks and the member page ----
  startTrial: { ar: "ابدأ تجربتك المجانية", en: "Start your free trial" },
  seePlans: { ar: "شوف الخطط", en: "See plans" },
  ourPlans: { ar: "الخطط", en: "Plans" },
  plansLead: { ar: "اختار الخطة اللي تناسبك. تقدر تبدأ بتجربة مجانية لو الخطة فيها تجربة.", en: "Pick the plan that suits you. Start with a free trial when the plan has one." },
  trialDays: { ar: "تجربة مجانية {n} يوم", en: "{n}-day free trial" },
  tryFree: { ar: "جرّب مجانًا", en: "Try it free" },
  subscribeNow: { ar: "اشترك", en: "Subscribe" },
  noPlans: { ar: "مفيش خطط متاحة دلوقتي.", en: "No plans are available right now." },
  programs: { ar: "البرامج", en: "Programs" },
  seeAllPrograms: { ar: "كل البرامج", en: "All programs" },
  ourTeam: { ar: "فريق المدربين", en: "Meet the team" },
  meetCoach: { ar: "المدرب", en: "Your coach" },
  whatMembersSay: { ar: "بيقولوا إيه عننا", en: "What members say" },
  faqTitle: { ar: "أسئلة شائعة", en: "Questions" },
  getTheApp: { ar: "حمّل التطبيق", en: "Get the app" },
  appStore: { ar: "App Store", en: "App Store" },
  googlePlay: { ar: "Google Play", en: "Google Play" },
  myPlans: { ar: "خططي", en: "My plans" },
  myPlansLead: { ar: "عضوياتك، وطلب خطة جديدة أو بدء تجربة.", en: "Your memberships, and asking for a new plan or starting a trial." },
  yourMemberships: { ar: "عضوياتك", en: "Your memberships" },
  noMemberships: { ar: "ما عندكش عضوية لسه. اختار خطة من تحت.", en: "You have no membership yet. Pick a plan below." },
  askForPlan: { ar: "اطلب خطة", en: "Ask for a plan" },
  statusPENDING: { ar: "في انتظار موافقة المدرب", en: "Waiting for the coach" },
  statusTRIAL: { ar: "تجربة مجانية", en: "Free trial" },
  statusACTIVE: { ar: "شغّالة", en: "Active" },
  statusEXPIRED: { ar: "منتهية", en: "Expired" },
  statusCANCELED: { ar: "ملغية", en: "Cancelled" },
  until: { ar: "لحد {date}", en: "until {date}" },
  trialStarted: { ar: "بدأت تجربتك المجانية.", en: "Your free trial has started." },
  requestSent: { ar: "وصل طلبك للمدرب. هيفعّل عضويتك بعد الدفع.", en: "Your request reached the coach. They will activate it once you've paid." },
  alreadyHaveIt: { ar: "عندك الخطة دي بالفعل", en: "You already have this plan" },
  payNote: { ar: "الدفع بيتم مع المدرب مباشرة، وبعدها بيفعّل عضويتك.", en: "You pay the coach directly, then they activate your membership." },
  signInToJoin: { ar: "سجّل دخولك الأول", en: "Sign in first" },

  // ---- library, recipes, calendar ----
  "lib.library": { ar: "المكتبة", en: "Library" },
  "lib.recipes": { ar: "الوصفات", en: "Recipes" },
  "lib.all": { ar: "كل الفيديوهات", en: "All videos" },
  "lib.allRecipes": { ar: "كل الوصفات", en: "All recipes" },
  "lib.favorites": { ar: "المفضلة", en: "Favorites" },
  "lib.history": { ar: "آخر ما شاهدته", en: "Recently opened" },
  "lib.search": { ar: "ابحث بالاسم...", en: "Search..." },
  "lib.duration": { ar: "المدة", en: "Duration" },
  "lib.dur.short": { ar: "أقل من 15 دقيقة", en: "Under 15 min" },
  "lib.dur.medium": { ar: "15 - 30 دقيقة", en: "15 - 30 min" },
  "lib.dur.long": { ar: "30 - 45 دقيقة", en: "30 - 45 min" },
  "lib.dur.xl": { ar: "أكتر من 45 دقيقة", en: "Over 45 min" },
  "lib.level": { ar: "المستوى", en: "Level" },
  "lib.level.BEGINNER": { ar: "مبتدئ", en: "Beginner" },
  "lib.level.INTERMEDIATE": { ar: "متوسط", en: "Intermediate" },
  "lib.level.ADVANCED": { ar: "متقدم", en: "Advanced" },
  "lib.trainer": { ar: "المدرب", en: "Trainer" },
  "lib.allTrainers": { ar: "كل المدربين", en: "All trainers" },
  "lib.tag.STYLE": { ar: "نوع التمرين", en: "Style" },
  "lib.tag.EQUIPMENT": { ar: "الأدوات", en: "Equipment" },
  "lib.tag.FOCUS": { ar: "التركيز", en: "Focus" },
  "lib.tag.BODY_AREA": { ar: "منطقة الجسم", en: "Body area" },
  "lib.sort": { ar: "الترتيب", en: "Sort by" },
  "lib.sortNew": { ar: "الأحدث", en: "Newest" },
  "lib.sortDuration": { ar: "الأقصر", en: "Shortest" },
  "lib.sortTitle": { ar: "الاسم", en: "Name" },
  "lib.clear": { ar: "مسح الفلاتر", en: "Clear filters" },
  "lib.results": { ar: "{n} نتيجة", en: "{n} results" },
  "lib.noResults": { ar: "مفيش نتائج بالفلاتر دي.", en: "Nothing matches these filters." },
  "lib.noFavorites": { ar: "ما حفظتش حاجة في المفضلة لسه.", en: "You haven't saved anything yet." },
  "lib.noHistory": { ar: "لسه ما فتحتش حاجة.", en: "You haven't opened anything yet." },
  "lib.favorite": { ar: "إضافة للمفضلة", en: "Add to favorites" },
  "lib.stoppedAt": { ar: "وقفت عند {time}", en: "stopped at {time}" },
  "lib.prev": { ar: "السابق", en: "Previous" },
  "lib.next": { ar: "التالي", en: "Next" },
  "cal.title": { ar: "جدول التمرين", en: "Workout calendar" },
  "cal.today": { ar: "تمرين النهارده", en: "Today's workout" },
  "cal.nothingToday": { ar: "مفيش تمرين متحدد النهارده. يوم راحة!", en: "Nothing scheduled today. Enjoy the rest day!" },
  "cal.empty": { ar: "المدرب لسه ما حطش جدول الشهر ده.", en: "Your coach hasn't planned this month yet." },
  "cal.progress": { ar: "خلّصت {done} من {total}", en: "{done} of {total} done" },
  "cal.markDone": { ar: "علّم إنه اتعمل", en: "Mark as done" },
  "cal.prev": { ar: "الشهر اللي فات", en: "Previous month" },
  "cal.next": { ar: "الشهر الجاي", en: "Next month" },

  // ---- home ----
  heroTitle: { ar: "اتعلّم أونلاين مع {name}", en: "Learn Online with {name}" },
  heroText: {
    ar: "كورسات ودروس ومصادر في مكان واحد. اتعلّم خطوة بخطوة وعلى راحتك.",
    en: "Courses, lessons and resources in one place. Learn step by step, at your own pace.",
  },
  exploreCourses: { ar: "تصفّح الكورسات", en: "Explore Courses" },
  watchIntro: { ar: "شاهد الفيديو التعريفي", en: "Watch Intro" },
  createAccount: { ar: "إنشاء حساب", en: "Create Account" },
  login: { ar: "تسجيل الدخول", en: "Login" },
  learningPaths: { ar: "مسارات التعلّم", en: "Learning Paths" },
  choosePath: { ar: "اختار المسار المناسب ليك", en: "Choose Your Path" },
  aboutMe: { ar: "عنّي", en: "About Me" },
  aboutName: { ar: "عن {name}", en: "About {name}" },

  // ---- courses ----
  ourCourses: { ar: "كورساتنا", en: "Our Courses" },
  coursesLead: { ar: "تصفّح الكورسات المتاحة واطلب الاشتراك.", en: "Browse the available courses and request a subscription." },
  noCourses: { ar: "مفيش كورسات متاحة دلوقتي.", en: "No courses available right now." },
  requestSub: { ar: "طلب اشتراك", en: "Request Subscription" },
  sending: { ar: "جاري الإرسال ...", en: "Sending ..." },
  subSent: {
    ar: "تم إرسال طلب الاشتراك، وهيتم مراجعته من المدرس قريبًا",
    en: "Your subscription request has been sent and will be reviewed by the teacher soon",
  },
  subFailed: { ar: "تعذّر إرسال الطلب", en: "Could not send the request" },
  loginFirst: { ar: "سجّل دخولك الأول علشان تطلب الاشتراك", en: "Please sign in first to request a subscription" },

  // ---- course detail ----
  course: { ar: "دورة تعليمية", en: "Course" },
  pickItem: { ar: "اختار عنصر من محتوى الدورة تحت علشان تشوفه هنا", en: "Pick an item from the course content below to view it here" },
  freePreview: { ar: "معاينة مجانية", en: "Free preview" },
  quality: { ar: "الجودة", en: "Quality" },
  qualityAuto: { ar: "تلقائي", en: "Auto" },
  videoPreparing: { ar: "جاري تجهيز الفيديو", en: "Preparing video" },
  videoPreparingMsg: { ar: "الفيديو بيتجهّز دلوقتي، جرّب بعد شوية", en: "This video is being prepared, try again in a little while" },
  videoFailed: { ar: "الفيديو غير متاح حالياً", en: "This video is not available right now" },
  enrolled: { ar: "إنت مشترك في الدورة دي", en: "You are enrolled in this course" },
  speed: { ar: "السرعة", en: "Speed" },
  fullscreen: { ar: "ملء الشاشة", en: "Fullscreen" },
  model3dLoading: { ar: "جاري تحميل النموذج ثلاثي الأبعاد...", en: "Loading the 3D model..." },
  model3dHint: { ar: "اسحب للتدوير · اسكرول للتكبير", en: "Drag to rotate · scroll to zoom" },
  model3dTitle: { ar: "عرض ثلاثي الأبعاد", en: "3D view" },

  // ---- gallery ----
  ourWork: { ar: "أعمالنا", en: "Our Work" },
  galleryLead: { ar: "مجموعة من المشاريع. افتح أي مشروع علشان تشوف صوره وفيديوهاته.", en: "A selection of projects. Open any project to see its photos and videos." },
  noProjects: { ar: "لسه مفيش مشاريع.", en: "No projects added yet." },
  projectVideo: { ar: "فيديو المشروع", en: "Project Video" },

  // ---- contact ----
  getInTouch: { ar: "تواصل معانا", en: "Get in Touch" },
  contactLead: { ar: "عندك سؤال عن كورس؟ تواصل معانا من البيانات دي.", en: "Questions about a course? Get in touch using the details below." },
  contactInfo: { ar: "بيانات التواصل", en: "Contact Info" },
  email: { ar: "البريد الإلكتروني", en: "Email" },
  phone: { ar: "التليفون", en: "Phone" },
  location: { ar: "العنوان", en: "Location" },

  // ---- resources ----
  resourcesTitle: { ar: "أدوات وقراءات مجانية", en: "Free Tools & Reading" },
  resourcesLead: { ar: "ملفات للتحميل وشروحات ومقالات تساعدك في رحلة التعلّم.", en: "Downloadable files, tutorials and articles to support your learning journey." },
  noResources: { ar: "لسه مفيش مصادر.", en: "No resources added yet." },
  downloads: { ar: "تحميلات مجانية", en: "Free Downloads" },
  tutorials: { ar: "شروحات", en: "Tutorials" },
  articles: { ar: "مقالات", en: "Articles" },
  download: { ar: "تحميل", en: "Download" },
  watch: { ar: "مشاهدة", en: "Watch" },
  read: { ar: "قراءة", en: "Read" },

  // ---- free videos ----
  noFreeLessons: { ar: "مفيش دروس مجانية متاحة دلوقتي.", en: "No free lessons available right now." },

  // ---- sign in / up ----
  welcomeBack: { ar: "أهلاً بيك تاني", en: "Welcome back" },
  signInTitle: { ar: "سجّل دخولك لحسابك", en: "Sign in to your account" },
  password: { ar: "كلمة السر", en: "Password" },
  signingIn: { ar: "جاري تسجيل الدخول ...", en: "Signing in ..." },
  signedIn: { ar: "تم تسجيل الدخول بنجاح", en: "Signed in successfully" },
  enterEmailPass: { ar: "اكتب البريد الإلكتروني وكلمة السر", en: "Enter your email and password" },
  badLogin: { ar: "بيانات الدخول غير صحيحة", en: "Incorrect email or password" },
  noAccount: { ar: "لسه ما عملتش حساب؟", en: "Don't have an account?" },
  newAccount: { ar: "إنشاء حساب جديد", en: "Create a new account" },
  joinUs: { ar: "انضم لينا", en: "Join us" },
  createTheAccount: { ar: "إنشاء الحساب", en: "Create account" },
  creating: { ar: "جاري إنشاء الحساب ...", en: "Creating your account ..." },
  fillRequired: { ar: "اكتب الاسم والبريد الإلكتروني وكلمة السر", en: "Fill in your name, email and password" },
  shortPassword: { ar: "كلمة السر لازم تكون 8 حروف على الأقل", en: "The password must be at least 8 characters" },
  accountCreated: { ar: "تم إنشاء الحساب، تقدر تسجّل دخولك دلوقتي", en: "Account created. You can sign in now" },
  accountFailed: { ar: "تعذّر إنشاء الحساب", en: "Could not create the account" },
  name: { ar: "الاسم", en: "Name" },
  governorate: { ar: "المحافظة", en: "Governorate" },
  chooseGovernorate: { ar: "اختار المحافظة", en: "Choose a governorate" },
  district: { ar: "المركز", en: "District" },
  chooseDistrict: { ar: "اختار المركز", en: "Choose a district" },
  studentPhone: { ar: "تليفون الطالب", en: "Student phone" },
  parentPhone: { ar: "تليفون ولي الأمر", en: "Parent phone" },
  gender: { ar: "النوع", en: "Gender" },
  chooseGender: { ar: "اختار النوع", en: "Choose" },
  male: { ar: "ذكر", en: "Male" },
  female: { ar: "أنثى", en: "Female" },
  grade: { ar: "الصف الدراسي", en: "Grade" },
  chooseGrade: { ar: "اختار المرحلة", en: "Choose a grade" },
  haveAccount: { ar: "عندك حساب بالفعل؟", en: "Already have an account?" },
  signInLink: { ar: "سجّل دخولك", en: "Sign in" },

  // ---- the platform-look pages (about, contact, courses, gallery, resources, free videos) ----
  seeCourses: { ar: "شوف الكورسات", en: "See the courses" },
  contactName: { ar: "تواصل مع {name}", en: "Contact {name}" },
  aboutSoon: { ar: "قريب هتعرف أكتر عن {name}", en: "More about {name} soon" },
  aboutEmpty: {
    ar: "الصفحة دي لسه ما اتملتش. لحد ما تتملا، الكورسات أحسن مكان تبدأ منه.",
    en: "This page has not been filled in yet. In the meantime, the courses are the best place to start.",
  },
  sendEmail: { ar: "ابعت إيميل", en: "Send an email" },
  call: { ar: "اتصل", en: "Call" },
  openWhatsapp: { ar: "افتح واتساب", en: "Open WhatsApp" },
  whatsappLabel: { ar: "واتساب", en: "WhatsApp" },
  copy: { ar: "نسخ", en: "Copy" },
  copied: { ar: "اتنسخ", en: "Copied" },
  noContactYet: { ar: "مفيش بيانات تواصل لسه", en: "No contact details yet" },
  noContactText: {
    ar: "{name} لسه ما ضافش بيانات تواصل هنا. صفحة الكورسات أحسن مكان تبدأ منه.",
    en: "{name} has not added any contact details here. The courses page is the best place to start.",
  },
  elsewhere: { ar: "تابعنا على", en: "Elsewhere" },
  learnWith: { ar: "اتعلّم مع {name}", en: "Learn with {name}" },
  coursesCountOne: { ar: "كورس واحد متاح", en: "1 course available" },
  coursesCount: { ar: "{n} كورسات متاحة", en: "{n} courses available" },
  noCoursesYet: { ar: "لسه مفيش كورسات", en: "No courses yet" },
  noCoursesText: {
    ar: "لسه ما اتنشرش أي كورس هنا. تواصل معانا وهنبلّغك أول ما ينزل.",
    en: "Nothing has been published here so far. Get in touch and we will let you know when it is.",
  },
  featured: { ar: "مميّز", en: "Featured" },
  details: { ar: "التفاصيل", en: "Details" },
  projectsOne: { ar: "مشروع واحد", en: "1 project" },
  projectsCount: { ar: "{n} مشاريع", en: "{n} projects" },
  nothingHereYet: { ar: "لسه مفيش حاجة هنا", en: "Nothing here yet" },
  noProjectsText: {
    ar: "لسه ما اتنشرش أي مشروع. ارجع بعدين، أو تواصل معانا.",
    en: "No projects have been published so far. Check back soon, or get in touch.",
  },
  video: { ar: "فيديو", en: "Video" },
  photoN: { ar: "صورة {n}", en: "Photo {n}" },
  prev: { ar: "السابق", en: "Previous" },
  next: { ar: "التالي", en: "Next" },
  downloadsBlurb: { ar: "ملفات تحتفظ بيها", en: "Files to keep" },
  tutorialsBlurb: { ar: "خطوة بخطوة", en: "Step by step" },
  articlesBlurb: { ar: "تستاهل وقتك", en: "Worth the time" },
  noResourcesYet: { ar: "لسه مفيش مصادر", en: "No resources yet" },
  noResourcesText: {
    ar: "لسه ما اتضافش ملفات أو شروحات أو مقالات هنا. الكورسات أحسن مكان تبدأ منه.",
    en: "No files, tutorials or articles have been added here yet. The courses are the best place to start.",
  },
  free: { ar: "مجانًا", en: "Free" },
  freeVideosLead: {
    ar: "مجموعة من دروس {name} المفتوحة للجميع. اتفرّج عليها قبل ما تشترك، واعرف طريقة الشرح.",
    en: "Lessons from {name} that are open to everyone. Watch them before you subscribe and get a feel for the teaching.",
  },
  freeLessonsOne: { ar: "درس واحد متاح", en: "1 lesson available" },
  freeLessonsCount: { ar: "{n} دروس متاحة", en: "{n} lessons available" },
  freeLesson: { ar: "درس مجاني", en: "Free lesson" },
  noFreeLessonsYet: { ar: "مفيش دروس مجانية دلوقتي", en: "No free lessons right now" },
  // ---- the newer themes' home blocks (components/HomeBlocks) ----
  "hb.browse": { ar: "تصفّح الكورسات", en: "Browse courses" },
  "hb.freeLesson": { ar: "شوف درس مجاني", en: "Watch a free lesson" },
  "hb.coursesEyebrow": { ar: "الكورسات", en: "Courses" },
  "hb.coursesTitle": { ar: "ابدأ من الكورس اللي يناسبك", en: "Start with the course that suits you" },
  "hb.coursesLead": { ar: "كل كورس بدروس مسجّلة وامتحانات وملفات، وتقدر تشوف أول درس مجانًا.", en: "Every course has recorded lessons, exams and files, and the first lesson is free." },
  "hb.allCourses": { ar: "كل الكورسات", en: "All courses" },
  "hb.lessonsN": { ar: "{n} درس", en: "{n} lessons" },
  "hb.stepsEyebrow": { ar: "إزاي تبدأ", en: "How it works" },
  "hb.stepsTitle": { ar: "خطوات بسيطة وتبقى جوّا", en: "A few steps and you are in" },
  "hb.step1": { ar: "سجّل حسابك", en: "Create your account" },
  "hb.step1Text": { ar: "دقيقة واحدة وتبقى جوّا: اسمك ورقمك والصف.", en: "One minute: your name, your number, your year." },
  "hb.step2": { ar: "اختار كورسك", en: "Pick your course" },
  "hb.step2Text": { ar: "ابدأ بالدرس المجاني، وكمّل بالكورس اللي يناسب مستواك.", en: "Start with the free lesson, then the course that fits your level." },
  "hb.step3": { ar: "اتعلّم وتابع تقدّمك", en: "Learn and track your progress" },
  "hb.step3Text": { ar: "فيديو وامتحانات وملفات، وتقرير بيقولك وصلت لفين.", en: "Videos, exams and files, and a report of how far you are." },
  "hb.aboutEyebrow": { ar: "عن المدرس", en: "About the teacher" },
  "hb.liveEyebrow": { ar: "الحصص المباشرة", en: "Live sessions" },
  "hb.liveTitle": { ar: "حصصك الجاية", en: "Your coming sessions" },
  "hb.liveGuestTitle": { ar: "حصص مباشرة كل أسبوع", en: "Live sessions every week" },
  "hb.liveGuestText": { ar: "مراجعات وحل امتحانات وأسئلة مفتوحة مع المدرس. سجّل دخولك وهتلاقي مواعيد حصصك هنا.", en: "Reviews, exam practice and open questions with the teacher. Sign in to see your sessions here." },
  "hb.liveNone": { ar: "مفيش حصص جاية دلوقتي. أول ما المدرس يحدد ميعاد هيظهر هنا.", en: "No coming sessions right now. They appear here as soon as the teacher schedules one." },
  "hb.allLive": { ar: "كل المواعيد", en: "All sessions" },
  "hb.freeEyebrow": { ar: "مجانًا", en: "Free" },
  "hb.freeTitle": { ar: "دروس مفتوحة للجميع", en: "Lessons open to everyone" },
  "hb.allFree": { ar: "كل الدروس المجانية", en: "All free lessons" },
  "hb.honorEyebrow": { ar: "لوحة الشرف", en: "Honour board" },
  "hb.honorTitle": { ar: "أوائل الطلاب", en: "Top students" },
  "hb.quotesEyebrow": { ar: "آراء الطلاب", en: "Reviews" },
  "hb.faqEyebrow": { ar: "أسئلة شائعة", en: "Questions" },
  "hb.faqLead": { ar: "لو سؤالك مش هنا كلّمنا ونرد عليك في نفس اليوم.", en: "If your question is not here, contact us and we answer the same day." },
  "hb.ctaTitle": { ar: "جاهز تبدأ مع {name}؟", en: "Ready to start with {name}?" },
  "hb.ctaText": { ar: "أول درس مجاني، ومن غير ما تدفع حاجة.", en: "The first lesson is free, no payment needed." },
  "hb.startFree": { ar: "ابدأ مجانًا", en: "Start free" },
  "hb.start": { ar: "ابدأ دلوقتي", en: "Start now" },
  "ff.site": { ar: "الموقع", en: "Site" },
  "ff.learn": { ar: "اتعلّم", en: "Learn" },
  "ff.reach": { ar: "تواصل معانا", en: "Get in touch" },
  "ff.top": { ar: "لفوق", en: "Back to top" },
  "hb.quizTag": { ar: "جرّب بنفسك", en: "Try it" },
  "hb.quizPick": { ar: "اختار إجابتك", en: "Pick your answer" },
  "hb.quizRight": { ar: "برافو، إجابة صح!", en: "Well done, that is right!" },
  "hb.quizWrong": { ar: "مش دي — الإجابة الصح باللون الأخضر", en: "Not this one — the right answer is in green" },
  "hb.quizAgain": { ar: "جرّب تاني", en: "Try again" },
  "hb.scroll": { ar: "انزل لتحت", en: "Scroll down" },
  "hb.askTitle": { ar: "لسه عندك سؤال؟", en: "Still have a question?" },
  "hb.askText": { ar: "ابعتلنا رسالة وهنرد عليك في أقرب وقت.", en: "Send us a message and we will get back to you soon." },
  "hb.example": { ar: "مثال", en: "Example" },
  "hb.perksEyebrow": { ar: "إزاي بتذاكر هنا", en: "How you learn here" },
  "hb.perksTitle": { ar: "كل اللي محتاجه عشان تذاكر صح", en: "Everything you need to study right" },
  "hb.perk1": { ar: "دروس تتفرج عليها في أي وقت", en: "Lessons you watch any time" },
  "hb.perk1Text": { ar: "فيديوهات مرتبة بالترتيب، وترجع لأي جزء وقت ما تحب.", en: "Videos in order; go back to any part whenever you like." },
  "hb.perk2": { ar: "امتحانات بتتصحح لوحدها", en: "Exams that mark themselves" },
  "hb.perk2Text": { ar: "تعرف درجتك وغلطاتك أول ما تخلّص.", en: "See your score and your mistakes as soon as you finish." },
  "hb.perk3": { ar: "حصص مباشرة مع المدرس", en: "Live sessions with the teacher" },
  "hb.perk3Text": { ar: "مراجعات وأسئلة على الهوا، ومواعيدها قدامك.", en: "Reviews and questions on air, with the times in front of you." },
  "hb.perk4": { ar: "من الموبايل أو الكمبيوتر", en: "On your phone or computer" },
  "hb.perk4Text": { ar: "الموقع شغال على أي جهاز، وتكمّل من مكان ما وقفت.", en: "Works on any device; pick up where you stopped." },
  "hb.roomTitle": { ar: "حصة مباشرة", en: "Live session" },
  "hb.roomChat1": { ar: "ممكن نعيد المسألة التانية؟", en: "Can we go over the second problem?" },
  "hb.roomChat2": { ar: "أكيد، خلّينا نحلّها خطوة خطوة", en: "Sure, step by step" },
  "hb.bioCourses": { ar: "الكورسات", en: "Courses" },
  "hb.bioLive": { ar: "الحصص المباشرة", en: "Live sessions" },
  "hb.bioContact": { ar: "تواصل", en: "Contact" },
  "hb.faq1": { ar: "إزاي أشترك في كورس؟", en: "How do I join a course?" },
  "hb.faq1a": { ar: "اعمل حساب الأول، وبعدين افتح صفحة الكورس واتبع الخطوات اللي ظاهرة فيها.", en: "Create an account, then open the course page and follow the steps shown there." },
  "hb.faq2": { ar: "أقدر أذاكر من الموبايل؟", en: "Can I study on my phone?" },
  "hb.faq2a": { ar: "أيوه، الموقع شغال على الموبايل والتابلت والكمبيوتر، وتقدّمك محفوظ على حسابك.", en: "Yes, the site works on phones, tablets and computers, and your progress is saved to your account." },
  "hb.faq3": { ar: "لو عندي سؤال في درس، أسأل فين؟", en: "Where do I ask about a lesson?" },
  "hb.faq3a": { ar: "ابعت سؤالك من صفحة «تواصل»، أو اسأله في الحصة المباشرة الجاية.", en: "Send it from the Contact page, or ask it in the next live session." },
  "hb.faq4": { ar: "أعرف مستوايا إزاي؟", en: "How do I know my level?" },
  "hb.faq4a": { ar: "كل امتحان بيتصحح أول ما تخلّصه، وبتشوف درجتك وإجاباتك الغلط.", en: "Every exam is marked as soon as you finish, with your score and your wrong answers." },
  // the specialty section's own words when the teacher has written none (layout.subject)
  "subj.problem": { ar: "مسألة الأسبوع|حاول تحلّها قبل ما تشوف الحل|كل أسبوع مسألة من امتحانات السنين اللي فاتت، واللي يحلّها صح يدخل لوحة الشرف.", en: "Problem of the week|Try it before you see the answer|A problem from past exams every week." },
  "subj.sim": { ar: "تجربة الأسبوع|شوف القانون بيتحرك قدامك|محاكاة جوّا الدرس: تغيّر الأرقام وتشوف النتيجة بتتغير قدامك، وبعدين تحل المسألة.", en: "Experiment of the week|Watch the law in motion|A simulation inside the lesson: change the numbers and watch the result." },
  "subj.periodic": { ar: "الجدول الدوري|كل عنصر له درسه|خواص كل عنصر وتفاعلاته المهمة في المنهج والأسئلة اللي جت عليه.", en: "Periodic table|Every element has its lesson|Properties, key reactions and past questions for every element." },
  "subj.body": { ar: "أجهزة الجسم|اختار الجهاز وابدأ منه|كل جهاز بخريطة دروسه من الخلية لحد العضو، مع أسئلة على كل جزء.", en: "Body systems|Pick a system and start|Every system with its lesson map, from the cell to the organ." },
  "subj.mcq": { ar: "بنك الأسئلة|جاوب وشوف الشرح فورًا|كل سؤال معاه شرح لكل اختيار ورابط للمحاضرة.", en: "Question bank|Answer and see why|Every question explains each choice and links to the lecture." },
  "subj.tools": { ar: "البرامج اللي هتتعلمها|أدوات الشغل الحقيقي|كل برنامج بمشروع من أوله لآخره، وملفات المشروع للتحميل.", en: "Software you will learn|The tools of the job|Every program with a full project and its files." },
  "subj.verse": { ar: "بيت الأسبوع|اقرأ، أعرب، وتذوّق|بيت شعر كل أسبوع بإعرابه وصوره البلاغية.", en: "Verse of the week|Read, parse, enjoy|A verse every week with its grammar and imagery." },
  "subj.levels": { ar: "اختبار المستوى|اعرف مستواك في 10 دقايق|اختبار قصير بيحدد مستواك من A1 لـ C2 وبيرشّحلك الكورس المناسب.", en: "Level test|Find your level in 10 minutes|A short test from A1 to C2 that suggests your course." },
  "subj.clubs": { ar: "نوادي المحادثة|اتكلّم مع ناس بنفس مستواك|مجموعات صغيرة كل أسبوع لكل لغة ومستوى، بمدرّس بيصحّح وإنت بتتكلم.", en: "Conversation clubs|Speak with people at your level|Small weekly groups per language and level." },
  "subj.projects": { ar: "مشاريع الكورس|هتبني الحاجات دي بإيدك|كل مشروع بالكود الكامل، وبتسلّمه وبيتراجع منّا.", en: "Course projects|You will build these yourself|Every project with full code, handed in and reviewed." },
  "subj.gallery": { ar: "معرض الطلاب|شغل طلابنا بيتكلم|أحسن مشاريع كل دفعة بتتعرض هنا.", en: "Student gallery|Our students' work|The best projects of every class." },
  "subj.tracks": { ar: "تراكات التدريب|اعزف مع الإيقاع بالسرعة اللي تناسبك|كل تمرين بتراك على أكتر من سرعة.", en: "Practice tracks|Play along at your speed|Every exercise with a track at several speeds." },
  "subj.juz": { ar: "متابعة الحفظ|خطة الثلاثين جزء|كل جزء بتخلّصه بيتعلّم، والمعلم بيكتبلك ملاحظاته على تلاوتك.", en: "Memorisation plan|The thirty parts|Every part you finish is marked, with notes on your recitation." },
  "subj.timeline": { ar: "الخط الزمني|العصور على خط واحد|كل عصر بأحداثه وشخصياته في درس.", en: "Timeline|The eras on one line|Every era with its events and people." },
  "subj.cases": { ar: "حالات عملية|اتعلّم من أرقام شركات حقيقية|كل حالة بقوائمها المالية وشيت التحليل.", en: "Case studies|Learn from real numbers|Every case with its statements and analysis sheet." },
  "subj.roadmap": { ar: "خريطة طريقك|من طالب لموظف|كل مرحلة بمهاراتها وتمارينها، وشهادة لما تخلصها.", en: "Your roadmap|From student to hire|Every stage with its skills, exercises and certificate." },
  "subj.plans": { ar: "الاشتراكات|اختار خطتك وابدأ النهارده|كل خطة فيها برنامج تمرين وتغذية ومتابعة.", en: "Plans|Pick your plan and start today|Every plan includes training, nutrition and follow-up." },
  "subj.meals": { ar: "يومك الصحي|جدول يوم كامل جاهز|فطار وغداء وعشا وسناك بسعرات محسوبة، ووصفة لكل وجبة.", en: "Your healthy day|A full day planned|Meals with counted calories and a recipe each." },
  "subj.journey": { ar: "رحلة التعلم|كل درس نجمة على الخريطة|الطفل بيجمع نجوم وشارات مع كل درس، وولي الأمر بيشوف التقرير.", en: "Learning journey|A star for every lesson|Children collect stars and badges, parents see the report." },
  "subj.features": { ar: "جوّا المنصة|كل اللي محتاجه علشان تذاكر صح|فيديو وامتحانات بتتصحح لوحدها وملفات وحصص مباشرة وتقارير لولي الأمر.", en: "Inside the platform|Everything you need to study well|Videos, self-marking exams, files, live sessions and reports." },
  "subj.dashboard": { ar: "لوحة الطالب|شوف تقدّمك في نظرة واحدة|الدروس اللي خلصتها ودرجاتك والحاجات اللي محتاج تراجعها في صفحة واحدة.", en: "Student dashboard|Your progress at a glance|Lessons done, grades and what to review, on one page." },
  "subj.certificate": { ar: "شهادة إتمام|خلّص الكورس وخد شهادتك|شهادة بكود تحقق تقدر تحطها في الـ CV.", en: "Certificate|Finish the course, get certified|A certificate with a verification code." },
  "subj.calendar": { ar: "جدولك|أسبوعك مترتّب|مواعيد الحصص والامتحانات في تقويم واحد، وتذكير قبل كل ميعاد.", en: "Your week|Your week in order|Sessions and exams in one calendar, with reminders." },
  "subj.compare": { ar: "قبل وبعد|الفرق بيبان في الدرجات|المذاكرة المنتظمة بتفرق: من أول امتحان لآخر امتحان في الكورس.", en: "Before and after|It shows in the grades|Steady study makes the difference from the first exam to the last." },

  // ---- the auth screen (pages/Auth, components/AuthAside, SignIn, SignUp) ----
  authTag: { ar: "منصّة تعليمية متكاملة", en: "Everything for your learning" },
  authTitleA: { ar: "منصّتك كلها في", en: "Your whole platform in" },
  authTitleB: { ar: "مكان واحد", en: "one place" },
  authLede: {
    ar: "دروسك، امتحاناتك، ملفّاتك ومتابعة تقدّمك — كلّها في انتظارك بعد {after}.",
    en: "Your lessons, exams, files and progress are all waiting for you once you {after}.",
  },
  authAfterSignIn: { ar: "تسجيل الدخول", en: "sign in" },
  authAfterSignUp: { ar: "إنشاء حسابك", en: "create your account" },
  perkLessons: { ar: "الدروس والفيديوهات", en: "Lessons and videos" },
  perkLessonsText: { ar: "شاهدها في أي وقت", en: "Watch any time" },
  perkExams: { ar: "الامتحانات والتقارير", en: "Exams and reports" },
  perkExamsText: { ar: "نتيجتك ومواضع الخطأ", en: "Your score and your slips" },
  perkFiles: { ar: "الملفّات والمرفقات", en: "Files and notes" },
  perkFilesText: { ar: "مذكّرات كل درس", en: "Notes for every lesson" },
  perkProgress: { ar: "متابعة تقدّمك", en: "Your progress" },
  perkProgressText: { ar: "إنجازك درسًا بدرس", en: "Lesson by lesson" },
  authTrust: { ar: "بياناتك محفوظة، ومش هنشاركها مع حد.", en: "Your details are kept safe and never shared." },
  siteLinks: { ar: "روابط الموقع", en: "Site links" },
  signInLead: { ar: "ادخل بريدك الإلكتروني وكلمة السر للمتابعة.", en: "Enter your email and password to continue." },
  showPass: { ar: "إظهار كلمة السر", en: "Show password" },
  hidePass: { ar: "إخفاء كلمة السر", en: "Hide password" },
  backToSite: { ar: "رجوع للموقع", en: "Back to the site" },
  signUpLeadSchool: { ar: "املأ بياناتك وابدأ من أول درس.", en: "Fill in your details and start from the first lesson." },
  signUpLeadGym: { ar: "املأ بياناتك وابدأ تدريبك.", en: "Fill in your details and start training." },
  passHint: { ar: "8 أحرف على الأقل", en: "At least 8 characters" },
  afterGovernorate: { ar: "بعد المحافظة", en: "after the governorate" },
  mobile: { ar: "الموبايل", en: "Mobile" },
  noGrades: { ar: "لسه مفيش مراحل مضافة", en: "No grades added yet" },
  noFreeLessonsText: {
    ar: "لسه ما اتضافش أي درس مجاني هنا. تقدر تشوف الكورسات المتاحة وتبدأ من هناك.",
    en: "No free lesson has been added here yet. Have a look at the courses and start there.",
  },
};

let language = "ar";

export function setLanguage(lang) {
  language = lang === "en" ? "en" : "ar";
}

export function getLanguage() {
  return language;
}

/** The label for `key` in the current language; {name}-style placeholders are filled from `vars`. */
export function t(key, vars) {
  const entry = STRINGS[key];
  let text = entry ? entry[language] || entry.ar : key;
  if (vars) {
    Object.keys(vars).forEach((k) => {
      text = text.split(`{${k}}`).join(vars[k] == null ? "" : String(vars[k]));
    });
  }
  return text;
}

/** Arrow pointing "forward" in the reading direction. */
export function forward() {
  return language === "en" ? "→" : "←";
}

export const STRING_KEYS = Object.keys(STRINGS);
